export const Ribos = new Map([
  ['Primilzis', {pavadinimas: 'Primilžis, kg', ribos: { min: 3, max: 200}}],
  ['Bazinis', {pavadinimas: 'Bazinis primilžis, kg', ribos: { min: 3, max: 200}}],
  ['Riebalai', {pavadinimas: 'Riebalų kiekis, R(%)', ribos: { min: 0.84, max: 10}}],
  ['Baltymai', {pavadinimas: 'Baltymų kiekis, B(%)', ribos: { min: 0.84, max: 10}}],
  ['Laktoze', {pavadinimas: 'Laktozės kiekis, L(%)', ribos: { min: 2, max: 9}}],
  ['Somatines', {pavadinimas: 'SLS', ribos: { min: 1, max: 10000}}],
  ['Urea', {pavadinimas: 'Urėja, U(mg%)', ribos: { min: 0, max: 100}}],
  ['Trukme', {pavadinimas: 'Laktacijos trukmė', ribos: { min: 0, max: 1000}}]
]);